import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { CreateMenu } from "services/apiService";
import toast from "react-hot-toast";

const MenuCreate = ({ isOpen, handleClose, isAutoComplete }) => {
  const [name, setName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!name) {
      return;
    }
    setLoading(true);
    const payload = {
      name,
      is_active: isActive ? 1 : 0,
    };

    try {
      const response = await CreateMenu(payload);
      if (response.status_code === 200) {
        toast.success("Menu created successfully");
        handleClose();
        isAutoComplete();
        setName("");
      } else {
        console.log("Menu creation failed");
      }
    } catch (error) {
      console.error("Error creating menu:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setName("");
    setIsActive(true);
    handleClose();
  };

  return (
    <Modal open={isOpen} onClose={handleCancel}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "400px",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          p: 4,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="h6"
          sx={{ mb: 2, textAlign: "center", color: "#3975b1" }}
        >
          Menu Create
        </Typography>

        <TextField
          label="Menu Name"
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          required
          sx={{ mb: 2 }}
        />

        <FormControlLabel
          control={
            <Switch
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
              name="isActive"
              color="primary"
            />
          }
          label="Active"
          sx={{ mb: 2 }}
        />

        <Box display="flex" justifyContent="space-between">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={loading || !name}
          >
            Submit
          </Button>
          <Button variant="contained" color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default MenuCreate;
